var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.326 3H6.67405C5.75141 3 5 3.73669 5 4.64127V14.3588C5 15.2633 5.75141 16 6.67405 16H12.3204C13.2486 16 14 15.2579 14 14.3533V4.64127C14 3.73669 13.2541 3 12.326 3ZM9.50276 14.18C8.77901 14.18 8.19891 13.6113 8.19891 12.9017C8.19891 12.1921 8.77901 11.6017 9.50276 11.6017C10.2265 11.6017 10.8066 12.1921 10.8066 12.9017C10.8066 13.6113 10.2265 14.18 9.50276 14.18ZM12.9006 9.34835C12.9006 9.73294 12.5801 10.0471 12.1878 10.0471H6.8177C6.42542 10.0471 6.10497 9.73294 6.10497 9.34835V4.7821C6.10497 4.39209 6.42542 4.08333 6.8177 4.08333H12.1878C12.5801 4.08333 12.9006 4.39209 12.9006 4.7821V9.34835Z",
    fill: "#546EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93369 5.57292C9.71309 5.31333 9.35142 5.31076 9.13814 5.50253C9.08283 5.53857 9.12496 5.50913 8.21547 6.63459C8.08288 6.79709 8.06079 7.01919 8.1547 7.20334C8.24308 7.39294 8.43647 7.51209 8.65195 7.51209H8.95028V8.22167C8.95028 8.51958 9.19891 8.76334 9.50277 8.76334C9.80663 8.76334 10.0553 8.51958 10.0553 8.22167V7.51209H10.3536C10.5691 7.51209 10.7624 7.39294 10.8508 7.20334C10.9447 7.01919 10.9227 6.79709 10.7901 6.62917C10.7458 6.57461 9.87885 5.50528 9.93369 5.57292Z",
    fill: "#546EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop6);
export default __webpack_public_path__ + "static/media/top6.90ce90c05586c3f8993adfa4c341ec22.svg";
export { ForwardRef as ReactComponent };